import { useContext } from 'react';
import { useWindowSize } from 'react-use';
import ThemeContext from '../contexts/themeContext';
import {
	ASIDE_WIDTH_PX,
	SPACER_PX,
	MOBILE_BREAKPOINT_SIZE,
	ASIDE_MINIMIZE_BREAKPOINT_SIZE,
  } from '../styles/settings/constants';

const useNavigationItemHandle = () => {
	const { setAsideStatus, setLeftMenuStatus, setRightMenuStatus } = useContext(ThemeContext);
	const { width } = useWindowSize();

	return () => {
		if (width < Number(MOBILE_BREAKPOINT_SIZE)) setAsideStatus(false);
		setLeftMenuStatus(false);
		setRightMenuStatus(false);
	};
};
export default useNavigationItemHandle;
